import React from 'react';
import Hero from '../Hero/Hero';
import Cards from '../Cards/Cards';
import Certs from '../Certs/Certs';
import '../../App.css';

function Home () {
  return (
    <>
      <Hero />
      <Cards />
      <Certs />
    </>
  );
}

export default Home
